import React from 'react';
import { Box } from '../SubComponents/Modals';
import { Text, Label } from '../SubComponents/Text';
import { Select } from '../SubComponents/Inputs';
import { ReactComponent as DownArrow } from '../Assets/Icons/down-black.svg';
import useLocalize from '../Hooks/useLocalize';

interface LocationProps {
  selectedShopId: string;
  shop?: {
    name: string;
  };
  shops: {
    id: string;
    name: string;
  }[];
  onChange: (shopId: string) => void;
  enabled?: boolean;
  error?: boolean;
}

const Location = (props: LocationProps) => {
  const localize = useLocalize();

  return (
    <Box
      error={props.error}
      justifyContent="space-between"
      mb="4"
      position="relative"
      display="flex"
      alignItems="center"
    >
      <Label htmlFor="location" lineHeight="35px">
        {localize('product.location')}
      </Label>
      {props.shops.length > 0 ? (
        <>
          <Select
            id="location"
            value={props.selectedShopId}
            onChange={(event) => props.onChange(event.target.value)}
            pl="3"
            pr="3"
            disabled={props.enabled === false}
          >
            <option
              label={`-- ${localize('product.chooseLocation')} --`}
              value={''}
              disabled
            >
              {`-- ${localize('product.chooseLocation')} --`}
            </option>
            {props.shops.map((shop) => (
              <option key={shop.id} label={shop.name} value={shop.id}>
                {shop.name}
              </option>
            ))}
          </Select>
          <DownArrow
            style={{
              width: 'auto',
              height: '10px',
              right: '12px',
              position: 'absolute',
              pointerEvents: 'none',
            }}
          />
        </>
      ) : (
        <Text lineHeight="35px" ml="3">
          {props.shop?.name}
        </Text>
      )}
    </Box>
  );
};

export default Location;
